export const LIMITYEARS = -3;
export const brands = [
    { brand: 'VW', label: 'VOLKSWAGEN' },
    { brand: 'AUDI', label: 'AUDI' },
    { brand: 'DUCATI', label: 'DUCATI' },
];
